<template>
  <vue-filter :options="options" :param="param" :label="label"/>
</template>

<script>
import VueFilter from './Filter.vue';

export default {
  components: { VueFilter },

  props: {
    param: {
      type: String,
      default: 'customerType',
    },
    label: {
      type: String,
      default: 'label',
    },
  },

  data() {
    return {
      options: [
        { label: 'Société', value: 'company' },
        { label: 'Particulier', value: 'personal' },
      ],
    };
  },
};
</script>
